<div class="imageWrapper">
  <sn-icon-button
    mat-dialog-close
    class="close-button"
    icon="close"
    color="danger"
    matTooltip="Close"
  ></sn-icon-button>
  <div class="fs-row">
    <div class="fs-col">
      <div class="section-img" *ngIf="this.mediaCarousel.length">
        <img [src]="this.activeMedia" class="image" (error)="setPlaceholderImage($event)" />
        <div *ngIf="this.mediaCarousel.length > 1" class="media-nav-scale">
          <button
            class="media-nav-scale-item"
            *ngFor="let media of this.mediaCarousel; trackBy: trackMedia"
            [class.active]="isActive(media)"
            (click)="selectMedia(media)"
          ></button>
        </div>
        <div *ngIf="this.mediaCarousel.length > 1" class="arrowBtns">
          <sn-icon class="arrowRight" (click)="nextImg()" fontSet="fal" fontIcon="fa-chevron-left">
          </sn-icon>
          <sn-icon
            class="arrowLeft"
            (click)="previousImg()"
            fontSet="fal"
            fontIcon="fa-chevron-right"
          >
          </sn-icon>
        </div>
      </div>
    </div>
  </div>
</div>
